import React from 'react'
import { Page } from '../../components/Page'
import '../creative.css'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader


function MOCHAZine() {
  return (
    <Page>
       <div className="title"> 
                <h1> MOCHA Zine </h1>
        </div>
        <div className='creative-text'> 
          I co-wrote an artistic zine that was published as part of the Mayday celebration at the Meuseum of Contemporary art in LA. 
          You can view the entire book below! 
            <img width="95%" src="zine/1.jpg"/>
            <img width="95%" src="zine/3.jpg"/>
            <img width="95%" src="zine/4.jpg"/>
            <img width="95%" src="zine/5.jpg"/>
            <img width="95%" src="zine/2_Page_1.jpg"/>
            <img width="95%" src="zine/2_Page_2.jpg"/>
            <img width="95%" src="zine/2_Page_3.jpg"/>
            <img width="95%" src="zine/6.jpg"/>
            <img width="95%" src="zine/7.jpg"/>
            <img width="95%" src="zine/8.jpg"/>
            <img width="95%" src="zine/9.jpg"/>
            <img width="95%" src="zine/10_Page_1.jpg"/>
            <img width="95%" src="zine/10_Page_2.jpg"/>
            <img width="95%" src="zine/10_Page_3.jpg"/>
            <img width="95%" src="zine/11.jpg"/>
            <img width="95%" src="zine/12.jpg"/>
            <img width="95%" src="zine/13.jpg"/>
            <img width="95%" src="zine/14.jpg"/>
            <img width="95%" src="zine/15.jpg"/>
            <img width="95%" src="zine/16.jpg"/>
            <img width="95%" src="zine/17.jpg"/>
            <img width="95%" src="zine/18.jpg"/>
            <img width="95%" src="zine/20.jpg"/>
            <img width="95%" src="zine/21.jpg"/>
            <img width="95%" src="zine/22.jpg"/>            
          <a href="https://ldrg.wordpress.com/" target="_blank" rel="noreferrer"> Check out our sponsor! </a>
        </div>
    </Page>
  )
}

export default MOCHAZine